import React from 'react';
import PropTypes from 'prop-types';

const doNothing = f => f;
function ModalBgCover(props) {
  return (
    <div
      className="lr-modal-bg-cover"
      onTouchStart={props.onTouch}
      onClick={props.closeMenu}
    />
  );
}

ModalBgCover.propTypes = {
  onTouch: PropTypes.func,
  closeMenu: PropTypes.func,
};

ModalBgCover.defaultProps = {
  onTouch: doNothing,
};

export default ModalBgCover;
